/* =========================================================
   NUVARY PDP — Interactive JS (Shopify .js.liquid)
   ========================================================= */

/* ---------- Asset URLs (resolved by Liquid) ---------- */
var IMG = {
  bottles:    "https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-pdp-bottles.png?v=1788631185",
  single:     "\/\/nuvary.com\/cdn\/shop\/t\/25\/assets\/nuvary-pdp-bottle-single.png?v=26364145910649600041788783261",
  bundle:     "\/\/nuvary.com\/cdn\/shop\/t\/25\/assets\/nuvary-pdp-bottles-bundle.png?v=131755876267318130661788783261",
  coconutOil: "https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-pdp-coconut-oil-v3.jpg?v=1788633809",
  lysine:     "https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-pdp-lysine-powder-v3.jpg?v=1788633809",
  mechanism:  "https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-pdp-mechanism-v3.jpg?v=1788633809",
  giftSoftgels: "\/\/nuvary.com\/cdn\/shop\/t\/25\/assets\/nuvary-pdp-gift-softgels.png?v=84613516256493019851788783271",
  giftGuide:  "\/\/nuvary.com\/cdn\/shop\/t\/25\/assets\/nuvary-pdp-gift-guide.png?v=122674618324775601788783271"
};

var PILLS = ['Happy Sex Life†','Relationships Restored†','Shame Gone†','Pain-Free†','Energy Restored†','Outbreak-Free†'];

var FACES = [
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-1.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-2.jpg?v=1788634335',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-3.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-4.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-5.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-6.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-7.jpg?v=1788634334',
  'https://cdn.shopify.com/s/files/1/0676/3275/8827/files/nuvary-carousel-8.jpg?v=1788634334'
];

/* Money in cents → "$12.34" (tier prices come from data-* attrs rendered by Liquid) */
var moneyCents = function(c){return '$'+(c/100).toFixed(2);};

/* ---------- Shipping is now handled server-side by Liquid localization ---------- */

/* ---------- Marquees ---------- */
function fillPills(id){
  var t = document.getElementById(id); if(!t) return;
  var h = '';
  for(var r=0; r<6; r++) PILLS.forEach(function(p){
    h += '<span class="pillx"><span class="ck">✓</span>'+p+'</span>';
  });
  t.innerHTML = h;
}
fillPills('pills-top');

(function(){
  var t = document.getElementById('faces-photos'); if(!t) return;
  var h = '';
  for(var r=0; r<2; r++) FACES.forEach(function(u){
    h += '<img src="'+u+'" alt="">';
  });
  t.innerHTML = h;
})();

/* ---------- Gallery ---------- */
(function(){
  var row = document.getElementById('thumbs'); if(!row) return;
  /* If Liquid already rendered product image thumbs, skip JS generation */
  if(!row.children.length){
    var thumbs = [IMG.bottles, IMG.single, IMG.bundle, IMG.coconutOil, IMG.lysine, IMG.mechanism];
    row.innerHTML = thumbs.map(function(u,i){
      return '<div class="thumb'+(i===0?' active':'')+'" data-src="'+u+'"><img src="'+u+'" alt=""></div>';
    }).join('');
  }
  /* Main image is a native scroll-snap carousel (#g-track) so swipes move the
     picture with the finger and snap, instead of swapping the src. */
  var track = document.getElementById('g-track');
  var mainImg = document.getElementById('main-img'); /* legacy single-image fallback */
  function thumbList(){ return Array.prototype.slice.call(row.querySelectorAll('.thumb')); }
  function markActive(i){
    thumbList().forEach(function(x, k){ x.classList.toggle('active', k === i); });
    var t = thumbList()[i];
    /* keep the active thumb centred in the strip without moving the page */
    if(t) row.scrollTo({ left: t.offsetLeft - row.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
  }
  function currentIndex(){
    if(track) return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    return thumbList().findIndex(function(x){ return x.classList.contains('active'); });
  }
  function goTo(i){
    var n = thumbList().length; if(!n) return;
    i = (i + n) % n;
    if(track){
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    } else if(mainImg){
      var t = thumbList()[i]; if(t) mainImg.src = t.getAttribute('data-src');
    }
    markActive(i);
  }
  function step(dir){ goTo(currentIndex() + dir); }
  row.addEventListener('click', function(e){
    var t = e.target.closest('.thumb'); if(!t) return;
    goTo(thumbList().indexOf(t));
  });
  /* Finger swipes / trackpad scrolls on the track → sync the active thumb */
  if(track){
    var st;
    track.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){ markActive(currentIndex()); }, 80);
    }, {passive:true});
    window.addEventListener('resize', function(){ track.scrollTo({ left: currentIndex() * track.clientWidth }); });
  }
  /* Prev / next arrows either side of the strip */
  var wrap = row.closest('.g-thumbs');
  var arrows = wrap ? wrap.querySelectorAll('.arr') : [];
  if(arrows.length === 2){
    arrows[0].setAttribute('role','button'); arrows[0].setAttribute('aria-label','Previous image'); arrows[0].tabIndex = 0;
    arrows[1].setAttribute('role','button'); arrows[1].setAttribute('aria-label','Next image'); arrows[1].tabIndex = 0;
    arrows[0].addEventListener('click', function(){ step(-1); });
    arrows[1].addEventListener('click', function(){ step(1); });
    [arrows[0], arrows[1]].forEach(function(a, idx){
      a.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); step(idx === 0 ? -1 : 1); } });
    });
  }
  /* Left / right keys while the gallery has focus, swipe on the main image */
  var gallery = row.closest('.gallery');
  if(gallery){
    gallery.tabIndex = -1;
    gallery.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ step(-1); } else if(e.key === 'ArrowRight'){ step(1); }
    });
  }
  /* Legacy single-image fallback keeps a simple swipe */
  if(mainImg && !track){
    var sx = null;
    mainImg.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    mainImg.addEventListener('touchend', function(e){
      if(sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if(Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
    }, {passive:true});
  }
})();

/* ---------- Buy Box (bundle builder — each tier is a product variant) ---------- */
function initBuyBox(id){
  var box = document.getElementById(id); if(!box) return;
  var tiers = box.querySelectorAll('.bb-tier');
  if(!tiers.length) return;
  var hasPlans = box.getAttribute('data-has-plans') === 'true';
  /* Default to automatic refills whenever a selling plan exists */
  var state = {sub: hasPlans};

  function deliveryDate(){
    var d = new Date(); d.setDate(d.getDate()+3);
    return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
  }
  function current(){
    var sel = box.querySelector('.bb-tier.sel');
    if(!sel){ sel = tiers[1] || tiers[0]; sel.classList.add('sel'); }
    return sel;
  }

  /* Price attribute to read: one-time or subscription (selling plan) */
  function priceAttr(){ return state.sub ? 'data-sub-price' : 'data-price'; }

  function update(){
    var t = current();
    var price   = parseInt(t.getAttribute(priceAttr()),10);
    var compare = parseInt(t.getAttribute('data-compare'),10);

    /* Re-render every tier's price + per-bottle for the active purchase mode */
    tiers.forEach(function(x){
      var p = parseInt(x.getAttribute(priceAttr()),10);
      var b = parseInt(x.getAttribute('data-bottles'),10) || 1;
      var nowEl = x.querySelector('.bb-price .now');
      if(nowEl) nowEl.textContent = moneyCents(p);
      var perEl = x.querySelector('.bb-per');
      if(perEl) perEl.textContent = moneyCents(Math.round(p / b)) + ' per bottle';
    });

    /* The form always submits qty 1 of the selected bundle variant */
    var idIn = box.querySelector('.js-variant-id');
    if(idIn) idIn.value = t.getAttribute('data-variant-id');
    var qty = box.querySelector('.js-qty');
    if(qty) qty.value = 1;
    var sp = box.querySelector('.js-selling-plan');
    if(sp) sp.disabled = !state.sub;

    tiers.forEach(function(x){ x.setAttribute('aria-checked', x === t ? 'true' : 'false'); });
    box.querySelectorAll('.bb-opt').forEach(function(o){
      o.classList.toggle('sel', (o.getAttribute('data-mode') === 'sub') === state.sub);
    });

    var aw = box.querySelector('.js-atc-was');
    if(aw) aw.textContent = compare > price ? moneyCents(compare) : '';
    var an = box.querySelector('.js-atc-now');
    if(an) an.textContent = moneyCents(price);

    var dd = box.querySelector('.js-deliv-date');
    if(dd) dd.textContent = deliveryDate();
  }

  function select(tier){
    tiers.forEach(function(x){ x.classList.remove('sel'); });
    tier.classList.add('sel');
    update();
  }

  box.addEventListener('click', function(e){
    var tier = e.target.closest('.bb-tier');
    if(tier){ select(tier); return; }
    var opt = e.target.closest('.bb-opt');
    if(opt && !opt.disabled){
      state.sub = hasPlans && opt.getAttribute('data-mode') === 'sub';
      update();
    }
  });
  box.addEventListener('keydown', function(e){
    var tier = e.target.closest('.bb-tier');
    if(tier && (e.key === 'Enter' || e.key === ' ')){ e.preventDefault(); select(tier); }
  });

  update();
}
initBuyBox('buybox-1');
initBuyBox('buybox-2');

/* ---------- Add to cart → Shrine cart drawer (no page redirect) ---------- */
(function(){
  var forms = document.querySelectorAll('.nv-atc-form');
  if(!forms.length) return;

  function getDrawer(){
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  forms.forEach(function(form){
    form.addEventListener('submit', function(e){
      var drawer = getDrawer();
      /* No drawer on this theme → let the browser do the normal POST */
      if(!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if(btn){ btn.classList.add('loading'); btn.setAttribute('aria-disabled','true'); }

      var fd = new FormData(form);
      if(typeof drawer.getSectionsToRender === 'function'){
        try{
          fd.append('sections', drawer.getSectionsToRender().map(function(s){return s.id;}).join(','));
          fd.append('sections_url', window.location.pathname);
        }catch(err){}
      }
      if(typeof drawer.setActiveElement === 'function'){
        try{ drawer.setActiveElement(document.activeElement); }catch(err){}
      }

      /* JSON body so the free e-book can ride along in the same request (one round trip,
         drawer shows both items at once). Gift only when the cart is known not to have it;
         nuvary-cart-gift reconciles anything else afterwards. */
      var item = {id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1};
      if(fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
      var items = [item];
      var G = window.NuvaryGift;
      if(G && G.isTriggerProduct && G.isTriggerProduct(form.getAttribute('data-product-id')) && G.hasGift && G.hasGift() === false){
        items.push({id: G.GIFT_VARIANT, quantity: 1, properties: {'_nuvary_gift': 'Free with Lysine + Monolaurin'}});
      }
      var body = {items: items};
      if(fd.get('sections')){ body.sections = fd.get('sections'); body.sections_url = fd.get('sections_url'); }

      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url + '.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify(body)
      }).then(function(r){ return r.json(); }).then(function(res){
        if(res.status){ throw new Error(res.description || res.message || 'Add to cart failed'); }
        try{
          if(window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate){
            publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form', productVariantId: fd.get('id'), cartData: res});
          }
        }catch(err){}
        drawer.renderContents(res);
        /* Shrine keeps the drawer collapsed while it carries is-empty (see nuvary-cart-gift) */
        drawer.classList.remove('is-empty');
        if(typeof drawer.open === 'function' && !drawer.classList.contains('active')){
          try{ drawer.open(); }catch(err){}
        }
      }).catch(function(){
        /* Anything odd → fall back to the classic cart page */
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }).finally(function(){
        if(btn){ btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
      });
    });
  });
})();

/* ---------- Accordion (product info) ---------- */
function acc(h){
  var i = h.parentElement, open = i.classList.contains('open');
  i.parentElement.querySelectorAll('.acc-i').forEach(function(x){ x.classList.remove('open'); });
  if(!open) i.classList.add('open');
}

/* ---------- Benefit cards (click to reveal) ---------- */
(function(){
  var cards = document.querySelectorAll('.bene-card');
  if(!cards.length) return;
  function toggle(card){
    var open = card.classList.contains('open');
    cards.forEach(function(c){ c.classList.remove('open'); c.querUpdate = null; var q=c.querySelector('.bene-q'); if(q) q.setAttribute('aria-expanded','false'); });
    if(!open){
      card.classList.add('open');
      var q = card.querySelector('.bene-q'); if(q) q.setAttribute('aria-expanded','true');
    }
  }
  cards.forEach(function(card){
    card.addEventListener('click', function(){ toggle(card); });
    card.addEventListener('keydown', function(e){
      if(e.key==='Enter' || e.key===' '){ e.preventDefault(); toggle(card); }
    });
  });
})();

/* ---------- Video testimonials — play/pause on click ---------- */
(function(){
  var vids = document.querySelectorAll('.vid[data-video-src]');
  if(!vids.length) return;
  vids.forEach(function(wrap){
    wrap.addEventListener('click', function(){
      var video = wrap.querySelector('video');
      if(!video) return;
      if(video.paused){
        /* Pause all other playing videos */
        document.querySelectorAll('.vid.playing video').forEach(function(v){
          v.pause(); v.closest('.vid').classList.remove('playing');
        });
        video.muted = false;
        video.play();
        wrap.classList.add('playing');
      } else {
        video.pause();
        wrap.classList.remove('playing');
      }
    });
    var video = wrap.querySelector('video');
    if(video){
      video.addEventListener('ended', function(){
        wrap.classList.remove('playing');
      });
    }
  });
})();

/* ---------- Journey timeline — progress fills as you scroll ---------- */
(function(){
  var items = document.querySelectorAll('#journey-timeline .milestone');
  if(!items.length) return;
  var ticking = false;
  function run(){
    ticking = false;
    var trigger = window.innerHeight * 0.55;
    items.forEach(function(item){
      var r = item.getBoundingClientRect();
      var start = r.top + 22;                 /* line starts below the dot */
      var len = Math.max(r.height - 22, 1);
      var p = (trigger - start) / len;
      p = Math.max(0, Math.min(1, p));
      var prog = item.querySelector('.tl-prog');
      if(prog) prog.style.height = (p*100).toFixed(1) + '%';
      item.classList.toggle('reached', trigger > r.top + 8);
    });
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  run();
})();

/* ---------- Generic slider (reasons, videos) ---------- */
function initSlider(root){
  var track = root.querySelector('.nv-track');
  var slides = root.querySelectorAll('.nv-slide');
  var dotsWrap = root.querySelector('.nv-dots');
  var prev = root.querySelector('.nv-prev');
  var next = root.querySelector('.nv-next');
  if(!track || !slides.length) return;

  function perView(){
    var sw = slides[0].getBoundingClientRect().width;
    return Math.max(1, Math.round(track.clientWidth / sw));
  }
  function pages(){ return Math.max(1, slides.length - perView() + 1); }
  function current(){
    var sw = slides[0].getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return Math.round(track.scrollLeft / (sw + gap));
  }
  function goTo(i){
    var sw = slides[0].getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    i = Math.max(0, Math.min(pages()-1, i));
    track.scrollTo({left: i*(sw+gap), behavior:'smooth'});
  }
  function buildDots(){
    if(!dotsWrap) return;
    var n = pages(), h = '';
    for(var i=0;i<n;i++) h += '<span class="nv-dot'+(i===0?' on':'')+'" data-i="'+i+'"></span>';
    dotsWrap.innerHTML = h;
    dotsWrap.style.display = n > 1 ? '' : 'none';
    if(root.querySelector('.nv-nav')) root.querySelector('.nv-nav').style.display = n > 1 ? '' : 'none';
  }
  function sync(){
    var c = current();
    if(dotsWrap) dotsWrap.querySelectorAll('.nv-dot').forEach(function(d,i){ d.classList.toggle('on', i===c); });
    if(prev) prev.disabled = c<=0;
    if(next) next.disabled = c>=pages()-1;
  }
  if(dotsWrap) dotsWrap.addEventListener('click', function(e){
    var d = e.target.closest('.nv-dot'); if(d) goTo(parseInt(d.getAttribute('data-i'),10));
  });
  if(prev) prev.addEventListener('click', function(){ goTo(current()-1); });
  if(next) next.addEventListener('click', function(){ goTo(current()+1); });
  var st;
  track.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(sync, 60); }, {passive:true});
  window.addEventListener('resize', function(){ buildDots(); sync(); });
  buildDots(); sync();
}
document.querySelectorAll('[data-slider]').forEach(initSlider);

/* ---------- Read more reviews ---------- */
(function(){
  var btn = document.querySelector('.js-read-more'); if(!btn) return;
  btn.addEventListener('click', function(){
    var sec = btn.closest('.shift');
    var open = sec.classList.toggle('open');
    btn.textContent = open ? 'Show Fewer Reviews' : 'Read More Reviews';
  });
})();

/* ---------- Countdown (resets every 2h) ---------- */
(function(){
  function tick(){
    var n=Date.now(), p=2*3600e3, r=p-(n%p);
    var h=Math.floor(r/3600e3), m=Math.floor(r%3600e3/60e3), s=Math.floor(r%60e3/1e3);
    var eh=document.getElementById('cd-h'), em=document.getElementById('cd-m'), es=document.getElementById('cd-s');
    if(eh) eh.textContent=String(h).padStart(2,'0');
    if(em) em.textContent=String(m).padStart(2,'0');
    if(es) es.textContent=String(s).padStart(2,'0');
  }
  tick(); setInterval(tick,1000);
})();

/* ---------- Smooth scroll for CTA anchor links ---------- */
(function(){
  document.querySelectorAll('.nuvary-pdp a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(el){
        e.preventDefault();
        el.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });
})();

/* ---------- UTM passthrough ---------- */
function applyUtm(){
  var utmKeys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id','fbclid','gclid','ttclid','sclid'];
  var params = new URLSearchParams(window.location.search), carry = new URLSearchParams();
  utmKeys.forEach(function(k){ if(params.has(k)) carry.set(k, params.get(k)); });
  var extra = carry.toString(); if(!extra) return;
  document.querySelectorAll('a[href*="nuvary.com"]').forEach(function(a){
    var href = a.getAttribute('href');
    if(href.indexOf(extra) !== -1) return;
    a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + extra);
  });
}
applyUtm();
